import { createContext } from "react";
import { ICorporateContext } from "./CorporateContextInterfaces";
import { NetworkStatus } from "@apollo/client";

export const initialState: ICorporateContext = {
    enabledNotifications: false,
    enabledNotificationsIds: [],
    rcaEnabled: false,
    isFullscreenActive: false,
    handleSetIsFullscreenActive: () => {},
    divisions: [],
    corporations: [],
    millsWithNoDivision: [],
    refreshCorporationsAndDivisions: async () => ({
        data: null,
        loading: false,
        error: undefined,
        networkStatus: NetworkStatus.ready,
    }),
    isLoadingCorporationsAndDivisions: true,
    currentUser: undefined,
    isLoadingCurrentUser: true,
    refreshCurrentUser: () => {},
};

export const CorporateContext = createContext(initialState);
